import tokens from 'vindi-ds-tokens';

const rootContainer = {
  width: '100%',
  display: 'grid',
  gridGap: tokens.spacing.mini.value,
  paddingTop: tokens.spacing.small.value,
  paddingBottom: tokens.spacing.xs.value,
};

export default {
  container: {
    ...rootContainer,
    gridTemplateColumns: '1fr 1fr',
  },
  noActions: {
    ...rootContainer,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gridColumn: '1/2',
  },
  navigation: {
    gridColumn: '1/2',
  },
  actions: {
    gridColumn: '2/3',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: tokens.spacing.xxs.value,
  },
  mobileRoot: {
    marginBottom: tokens.spacing.mini.value,
    backgroundColor: tokens.color.prsm.neutral[100].value,
    borderRadius: '50%',
  },
};
